import { Turnstile as ReactTurnstile } from '@marsidev/react-turnstile';
import React from 'react';

export function Turnstile({ action, onSuccess, retries, theme = 'light' }) {
  const innerRef = React.useRef(null);
  const onError = React.useCallback(() => {
    innerRef.current.reset();
  }, []);

  const onExpire = React.useCallback(() => {
    innerRef.current.reset();
  }, []);

  React.useEffect(() => {
    innerRef.current.reset();
  }, [retries]);

  return (
    <ReactTurnstile
      ref={innerRef}
      siteKey={window.config.turnstile_site_key}
      onSuccess={onSuccess}
      onError={onError}
      onExpire={onExpire}
      options={{ action, theme, size: 'flexible' }}
    />
  );
}
